import {SearchSelectOption} from '../../../../../_metronic/helpers/components/SearchSelect'
import {ProductServicePriceSource} from './core/_models'

export const manualPriceSourceOption: SearchSelectOption = {
  value: 1,
  label: 'قیمت دستی',
}

const invalidPriceSourceTypes = [23, 25, 27, 29]

const fallbackOnlinePriceSourceOptions: SearchSelectOption[] = [
  {value: 2, label: 'طلای 18 عیار'},
  {value: 3, label: 'سکه بهار آزادی'},
  {value: 4, label: 'سکه پارسیان 1/000'},
  {value: 5, label: 'نقره 999'},
  {value: 6, label: 'طلای 24 عیار'},
  {value: 7, label: 'طلای 18 عیار / 740'},
  {value: 8, label: 'طلای دست دوم'},
  {value: 9, label: 'مثقال طلا'},
  {value: 10, label: 'آبشده نقدی'},
  {value: 11, label: 'آبشده بنکداری'},
  {value: 12, label: 'آبشده کمتر از کیلو'},
  {value: 13, label: 'آبشده شنبه‌ای'},
  {value: 14, label: 'مثقال / عیار جهانی'},
  {value: 15, label: 'مثقال / حواله دلار'},
  {value: 16, label: 'مثقال / حواله دلار سکه'},
  {value: 17, label: 'سکه امامی'},
  {value: 18, label: 'نیم سکه'},
  {value: 19, label: 'ربع سکه'},
  {value: 20, label: 'سکه گرمی'},
  {value: 21, label: 'نقره 925'},
  {value: 22, label: 'سکه پارسیان 0/100'},
  {value: 24, label: 'سکه پارسیان 0/200'},
  {value: 26, label: 'سکه پارسیان 0/300'},
  {value: 28, label: 'سکه پارسیان 0/400'},
  {value: 30, label: 'سکه پارسیان 0/500'},
  {value: 31, label: 'سکه پارسیان 0/600'},
  {value: 32, label: 'سکه پارسیان 0/700'},
  {value: 33, label: 'سکه پارسیان 0/800'},
  {value: 34, label: 'سکه پارسیان 0/900'},
  {value: 35, label: 'سکه پارسیان 1/100'},
  {value: 36, label: 'سکه پارسیان 1/200'},
  {value: 37, label: 'سکه پارسیان 1/300'},
  {value: 38, label: 'سکه پارسیان 1/400'},
  {value: 39, label: 'سکه پارسیان 1/500'},
]

const sortPriceSourceOptions = (options: SearchSelectOption[]) =>
  [...options].sort((first, second) => {
    const firstValue = Number(first.value || 0)
    const secondValue = Number(second.value || 0)

    if (firstValue === 1) {
      return -1
    }

    if (secondValue === 1) {
      return 1
    }

    const labelCompare = String(first.label || '')
      .trim()
      .localeCompare(String(second.label || '').trim(), 'fa', {
        numeric: true,
        sensitivity: 'base',
      })

    return labelCompare !== 0 ? labelCompare : firstValue - secondValue
  })

export const defaultPriceSourceOptions = sortPriceSourceOptions([
  manualPriceSourceOption,
  ...fallbackOnlinePriceSourceOptions,
])

const getPriceSourceOptionLabel = (source: ProductServicePriceSource) => {
  const name = source.psn || `منبع قیمت ${source.pst}`
  const profiles = source.profiles?.filter(Boolean)
  return profiles && profiles.length > 0 ? `${name} (${profiles.join('، ')})` : name
}

export const getPriceSourceOptions = (
  sources: ProductServicePriceSource[]
): SearchSelectOption[] => {
  const options = [...defaultPriceSourceOptions]

  sources
    .filter((item) => {
      const value = Number(item.pst || 0)
      return value > 1 && !invalidPriceSourceTypes.includes(value)
    })
    .forEach((item) => {
      const value = Number(item.pst)
      const nextOption = {
        value,
        label: getPriceSourceOptionLabel(item),
      }
      const existingIndex = options.findIndex((option) => Number(option.value) === value)
      if (existingIndex >= 0) {
        options[existingIndex] = nextOption
      } else {
        options.push(nextOption)
      }
    })

  return sortPriceSourceOptions(options)
}

export const getPriceSourceLabel = (
  priceSourceType: number,
  options: SearchSelectOption[] = defaultPriceSourceOptions
) => {
  const option = options.find((item) => Number(item.value) === Number(priceSourceType))
  return option?.label?.toString() || 'قیمت دستی'
}
